module.exports = __webpack_public_path__ + "images/ds-landing-bi-instructor-shashank-kalanithi-mobile.webp";